<!-- Back Button -->
<div class="container">
  <div class="d-none d-lg-block pt-3">
    <button class="back-btn border-0 d-flex align-items-center justify-content-center" [routerLink]="'/rewards/auctions'">
      <span class="material-icons text-white">arrow_back_ios_new</span>
    </button>
  </div>
</div>

<!-- Points Summary -->
<div class="container">
  <fgb-points-summary-bar [backButtonLink]="'/rewards/auctions'" [backButtonTitle]="'Auctions'"></fgb-points-summary-bar>
</div>

<!-- Auction Details -->
<fgbcl-auction-details [auctionId]="id"></fgbcl-auction-details>
